export default __webpack_public_path__ + "static/media/(7).486fb5c9.jpg";